import { render, staticRenderFns } from "./HomeBaseLabel.vue?vue&type=template&id=09af1013&scoped=true&"
import script from "./HomeBaseLabel.vue?vue&type=script&lang=js&"
export * from "./HomeBaseLabel.vue?vue&type=script&lang=js&"
import style0 from "./HomeBaseLabel.vue?vue&type=style&index=0&id=09af1013&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af1013",
  null
  
)

export default component.exports